<div
  class="menu-trigger-for"
  [matMenuTriggerFor]="menu"
  [attr.aria-label]="hamburgerMenuAriaLabel"
>
  <button mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <ng-content />
</mat-menu>
